import React from "react";

export const StatsCard = ({ count, title, icon, color = "bg-indigo-500", onClick }) => {

    return (
        <div
            onClick={onClick}
            className="group cursor-pointer bg-white hover:bg-secondary-200  rounded-2xl shadow-sm hover:shadow-xl 
      border border-gray-100 p-6 transition-all duration-300 hover:-translate-y-1"
        >
            <div className="flex items-center justify-between">

                {/* Left Content */}
                <div>

                    <p className="text-gray-500 text-sm font-medium">
                        {title}
                    </p>

                    <h2 className="text-3xl font-bold text-gray-900 mt-2">
                        {count}
                    </h2>

                </div>

                {/* Icon */}
                <div
                    className={`w-12 h-12 flex items-center justify-center rounded-xl text-white
                     group-hover:scale-110 transition bg-primary-600`}
                >
                    {icon}
                </div>

            </div>

        </div>
    );

};